'use strict'

module.exports = caseSensitiveTransform

function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/property-information/lib/util/case-sensitive-transform.js
// module id = 2819
// module chunks = 0